import { createSlice } from "@reduxjs/toolkit";

export const CommonSlice = createSlice({
    name: "drawerTabs",
    initialState: {
        // For Suppliers
        productPageType: "add",
        packagePageType: "add",
        basePackageId: "",
    },
    reducers: {
        setProductPageType: (state, action) => {
            state.productPageType = action.payload;
        },
        setPackagePageType: (state, action) => {
            state.packagePageType = action.payload;
        },
        setBasePackageId: (state, action) => {
            state.basePackageId = action.payload;
        },
    },
});

export const { setProductPageType, setPackagePageType, setBasePackageId } = CommonSlice.actions;

export default CommonSlice.reducer;
